module.exports = require('lodash').mapValues